import { render, staticRenderFns } from "./LegacyButton.vue?vue&type=template&id=33579844&scoped=true&"
import script from "./LegacyButton.vue?vue&type=script&lang=js&"
export * from "./LegacyButton.vue?vue&type=script&lang=js&"
import style0 from "./LegacyButton.vue?vue&type=style&index=0&id=33579844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33579844",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
